(function () {
  if (window.__bsgAcc) return;
  window.__bsgAcc = true;
  var mq = window.matchMedia('(max-width:767px)');
  function apply() {
    document.querySelectorAll('[data-bsg-acc]').forEach(function (d) { d.open = !mq.matches; });
  }
  apply();
  if (mq.addEventListener) mq.addEventListener('change', apply); else mq.addListener(apply);
  document.addEventListener('click', function (e) {
    var s = e.target.closest && e.target.closest('[data-bsg-acc] > summary');
    if (s && !mq.matches) e.preventDefault();
  });
  document.addEventListener('shopify:section:load', apply);
})();